import { Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { ApiError_FromException_Z57DF7D6E, ErrorDetail, ApiError_Technical_Z184EB5A, ApiError_ForAuthenticationError_2C0F150A, ApiError_$reflection } from "./Shopfoo.Shared/Errors.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { option_type, record_type, lambda_type, class_type, union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { QueryDataAndTranslations$1, Request$1, FullContext__get_Lang, UnitTestSession_$reflection, ServerError_$reflection, RootApi_$reflection } from "./Shopfoo.Shared/Remoting.js";
import { User_$reflection } from "./Shopfoo.Domain.Types/Security.js";
import { api as api_1 } from "./Server.js";
import { Cmd_OfAsync_start, Cmd_OfAsyncWith_either } from "./fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Cmd_OfAsyncWith_either as Cmd_OfAsyncWith_either_1 } from "./fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { startImmediate } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { ProxyRequestException__get_ResponseText, ProxyRequestException } from "./fable_modules/Fable.Remoting.Client.7.32.0/Types.fs.js";
import { AppTranslations__get_EmptyPages } from "./Shopfoo.Shared/Translations.js";
import { value as value_1 } from "./fable_modules/fable-library-js.4.24.0/Option.js";

export class ApiCall$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Start", "Done"];
    }
}

export function ApiCall$1_$reflection(gen0) {
    return union_type("Shopfoo.Client.Remoting.ApiCall`1", [gen0], ApiCall$1, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", ApiError_$reflection()]]])]]]);
}

export class ApiRequestArgs$2 extends Record {
    constructor(Call, Error$, Success) {
        super();
        this.Call = Call;
        this.Error = Error$;
        this.Success = Success;
    }
}

export function ApiRequestArgs$2_$reflection(gen0, gen1) {
    return record_type("Shopfoo.Client.Remoting.ApiRequestArgs`2", [gen0, gen1], ApiRequestArgs$2, () => [["Call", lambda_type(RootApi_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", ServerError_$reflection()]]])]))], ["Error", lambda_type(ApiError_$reflection(), gen1)], ["Success", lambda_type(gen0, gen1)]]);
}

export function Response_toApiResult(response) {
    if (response.tag === 1) {
        if (response.fields[0].tag === 1) {
            return new FSharpResult$2(1, [ApiError_ForAuthenticationError_2C0F150A(response.fields[0].fields[0])]);
        }
        else {
            return new FSharpResult$2(1, [response.fields[0].fields[0]]);
        }
    }
    else {
        return new FSharpResult$2(0, [response.fields[0]]);
    }
}

export class Cmder extends Record {
    constructor(User, UnitTestSession) {
        super();
        this.User = User;
        this.UnitTestSession = UnitTestSession;
    }
}

export function Cmder_$reflection() {
    return record_type("Shopfoo.Client.Remoting.Cmder", [], Cmder, () => [["User", User_$reflection()], ["UnitTestSession", option_type(UnitTestSession_$reflection())]]);
}

/**
 * Wraps a call to the Remoting API, offering an object-based syntax
 * abstracting an Elmish <c>Cmd.OfAsync.either</c>.
 */
export function Cmder__ofApiRequest_Z503C4AF9(this$, args) {
    let patternInput;
    const matchValue = this$.UnitTestSession;
    patternInput = ((matchValue == null) ? [api_1, (task_1) => ((arg_1) => ((ofSuccess_1) => ((ofError_1) => Cmd_OfAsyncWith_either((x) => {
        Cmd_OfAsync_start(x);
    }, task_1, arg_1, ofSuccess_1, ofError_1))))] : [matchValue.MockedApi, (task) => ((arg) => ((ofSuccess) => ((ofError) => Cmd_OfAsyncWith_either_1((computation) => {
        startImmediate(computation);
    }, task, arg, ofSuccess, ofError))))]);
    return patternInput[1](args.Call)(patternInput[0])((response) => {
        const matchValue_1 = Response_toApiResult(response);
        if (matchValue_1.tag === 1) {
            return args.Error(matchValue_1.fields[0]);
        }
        else {
            return args.Success(matchValue_1.fields[0]);
        }
    })((exn) => {
        let exn_1;
        return args.Error((exn instanceof ProxyRequestException) ? ((exn_1 = exn, ApiError_Technical_Z184EB5A(exn_1.message, undefined, undefined, new ErrorDetail(ProxyRequestException__get_ResponseText(exn_1))))) : ApiError_FromException_Z57DF7D6E(exn, this$.User));
    });
}

export function Shopfoo_Shared_Remoting_FullContext__FullContext_get_Cmder(this$) {
    return new Cmder(this$.User, this$.UnitTestSession);
}

export function Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(this$, body) {
    const secureRequest = new Request$1(this$.Token, FullContext__get_Lang(this$), body);
    return [Shopfoo_Shared_Remoting_FullContext__FullContext_get_Cmder(this$), secureRequest];
}

export function Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareQueryWithTranslations_1505(this$, query) {
    return Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(this$, new QueryDataAndTranslations$1(query, AppTranslations__get_EmptyPages(this$.Translations)));
}

export class Remote$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Empty", "Loading", "LoadError", "Loaded"];
    }
}

export function Remote$1_$reflection(gen0) {
    return union_type("Shopfoo.Client.Remoting.Remote`1", [gen0], Remote$1, () => [[], [], [["Item", ApiError_$reflection()]], [["Item", gen0]]]);
}

export function Remote_ofOption(_arg) {
    if (_arg == null) {
        return new Remote$1(0, []);
    }
    else {
        return new Remote$1(3, [value_1(_arg)]);
    }
}

export function Remote_isLoaded(_arg) {
    if (_arg.tag === 3) {
        return true;
    }
    else {
        return false;
    }
}

export function Remote_ofResult(_arg) {
    if (_arg.tag === 1) {
        return new Remote$1(2, [_arg.fields[0]]);
    }
    else {
        return new Remote$1(3, [_arg.fields[0]]);
    }
}

